import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import PropTypes from 'prop-types';
import React from 'react';
import { globalStyles as styles } from './style/gstheme';
import { DATATYPE_LABELS, DEFAULT_LANG } from './utils/constants';

class Datatype extends React.Component {

    render() {

        const { datatype, classes, invalid, dataTest } = this.props;

        return (
            <Tooltip title={datatype}>
                <div data-test={dataTest} className={classes.datatype} style={invalid ? { backgroundColor: '#FF6F00' } : {}}>
                    {
                        DATATYPE_LABELS[datatype] ?
                            DATATYPE_LABELS[datatype][DEFAULT_LANG]
                            :
                            "Custom"
                    }
                </div>
            </Tooltip>
        );
    }
}

Datatype.defaultProps = {
    invalid: false,
    dataTest: "datatype"
};

Datatype.propTypes = {
    dataTest: PropTypes.string,
    datatype: PropTypes.string,
    invalid: PropTypes.bool,
    classes: PropTypes.object
};

export default withStyles(styles)(Datatype);